import { Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, Children, cloneElement, isValidElement } from 'react';
import { TooltipTrigger } from './tooltip-trigger';
import { TooltipContent } from './tooltip-content';
export var BaseTooltip = function (_a) {
    var children = _a.children;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var triggerRef = useRef(null);
    var handleMouseEnter = function () { return setIsOpen(true); };
    var handleMouseLeave = function () { return setIsOpen(false); };
    var childrenArray = Children.toArray(children);
    var trigger = childrenArray.find(function (child) { return isValidElement(child) && child.type === TooltipTrigger; });
    var content = childrenArray.find(function (child) { return isValidElement(child) && child.type === TooltipContent; });
    return (_jsxs(_Fragment, { children: [trigger &&
                cloneElement(trigger, {
                    triggerRef: triggerRef,
                    onMouseEnter: handleMouseEnter,
                    onMouseLeave: handleMouseLeave,
                }), content &&
                cloneElement(content, {
                    isOpen: isOpen,
                    triggerRef: triggerRef,
                })] }));
};
